export default __webpack_public_path__ + "static/fdlp-fdb1d580853985c422fddb3a8aaaba2b.png";